import React from 'react';
import './styles/location.css';

const LocationMap = () => {

  return (
    
      <div className="map-content">
        {/* Replace the iframe src with your actual Google Maps embed URL */}
        <iframe
          title="York Engineering Location"
          src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d214.256524217278!2d87.27850966568667!3d26.446097773317337!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sus!4v1739393740699!5m2!1sen!2sus" 
          width="600" 
          height="450" 
          style={{ border: 0 }}
          allowfullscreen="" 
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade">
        </iframe>
          
      
      </div>
      
  );
};

export default LocationMap;